import React from 'react';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { auth0Config } from './auth0-config';

// Debug component to monitor Auth0 state
const Auth0StateMonitor = () => {
  const { isAuthenticated, isLoading, user, error } = useAuth0();
  
  React.useEffect(() => {
    console.log('🔍 Auth0 State Monitor:', {
      isAuthenticated,
      isLoading,
      hasUser: !!user,
      userEmail: user?.email,
      error: error?.message,
      errorDetails: error
    });
  }, [isAuthenticated, isLoading, user, error]);

  return null;
};

const Auth0ProviderWrapper = ({ children }) => {
  const onRedirectCallback = (appState) => {
    console.log('✅ Auth0 redirect callback triggered:', appState);
    console.log('Current URL:', window.location.href);
    
    // Navigate to the page the user was on before login or to home
    const targetUrl = appState?.returnTo || window.location.pathname;
    console.log('Navigating to:', targetUrl);
    window.history.replaceState({}, document.title, targetUrl);
  };

  // Check for callback parameters
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hasCode = params.has('code');
    const hasError = params.has('error');
    const hasState = params.has('state');
    
    if (hasCode || hasError || hasState) {
      console.log('🔄 Detected Auth0 callback params:', {
        hasCode,
        hasError,
        hasState,
        error: params.get('error'),
        errorDescription: params.get('error_description'),
        code: hasCode ? 'present' : 'missing',
        fullUrl: window.location.href
      });
    }
  }, []);

  console.log('🔧 Auth0 Provider Config:', {
    domain: auth0Config.domain,
    clientId: auth0Config.clientId,
    redirectUri: auth0Config.authorizationParams.redirect_uri,
    audience: auth0Config.authorizationParams.audience || 'not set',
    scope: auth0Config.authorizationParams.scope,
    useRefreshTokens: true,
    cacheLocation: 'localstorage'
  });

  // Check if config is valid
  if (!auth0Config.domain || auth0Config.domain === 'your-domain.auth0.com') {
    console.error('❌ Auth0 domain not configured! Check your .env file');
  }
  if (!auth0Config.clientId || auth0Config.clientId === 'your-client-id') {
    console.error('❌ Auth0 clientId not configured! Check your .env file');
  }

  return (
    <Auth0Provider 
      {...auth0Config}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <Auth0StateMonitor />
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWrapper; 